// Define base styles for ovals
export const defaultBtnColorOptions = {
    "idle": {
        "background": {
            "color": [
                'rgb(34, 203, 255)',
                'rgb(25, 149, 255)'
            ]
        },
        "hover": {
            "color": [
                'rgba(0, 70, 255, 0.95)',
                'rgba(0, 156,  255, 0.95)'
            ]
        }
    },
    "listen": {
        "background": {
            "color": [
                'rgba(0, 70, 255, 0.95)',
                'rgba(0, 156,  255, 0.95)'
            ]
        },
        "hover": {
            "color": ['rgba(0, 70, 255, 0.95)',
                'rgb(0, 70, 255)']
        },
    },
    "process": {
        "background": {
            "color": [
                'rgba(0, 255, 205, 0.95)',
                'rgba(0, 115, 255, 0.95)'
            ]

        },
        "hover": {
            "color": [
                'rgb(0, 115, 255)',
                'rgba(0, 115, 255, 0.95)'
            ]
        }
    },

    "reply": {
        "background": {
            "color": [
                'rgba(122, 40, 255, 0.95)',
                'rgba(61, 122, 255, 0.95)'
            ]
        },
        "hover": {
            "color": [
                'rgba(122, 40, 255, 0.95)',
                'rgb(122, 40, 255)'
            ]
        },
    },
    "textChat": {
        "background": {
            "color": ["#1eb6e5", "#1995ff"],
            "angle": 45
        },
        "hover": {
            "color": ["#1ba3ce", "#1686e5"],
            "angle": 45
        },
        "shadow": {
            "color": ["#6693bc", "#b3c9de"]
        }
    },
    "textChatAvatar": {
        "background": {
            "color": ["#1eb6e5", "#1995ff"],
            "angle": 45
        },
        "hover": {
            "color": ["#1ba3ce", "#1686e5"],
            "angle": 45
        },
        "shadow": {
            "color": ["#6693bc", "#b3c9de"]
        }
    },
    "textChatUserAvatar": {
        "background": {
            "color": ["#b2d6ff", "#b2d6ff"],
            "angle": 45
        },
        "hover": {
            "color": ["#1ba3ce", "#1686e5"],
            "angle": 45
        },
        "shadow": {
            "color": ["#6693bc", "#b3c9de"]
        }
    }
};